// 国内市场
<template>
  <div class="subpage china" :style="rootVars">
    <div class="bottom">
      <div class="flx-bc head">
        <span class="link" @click="processShow=true">{{ $C('china','linkChain','中国乳制品产业链') }}</span>
        <span class="link" @click="brandShow=true">{{ $C('china','linkBrand','中国市场乳制品品牌 TOP 30') }}</span>
        <span class="link" @click="teaShow=true">{{ $C('china','linkTea','中国市场茶饮品牌 TOP 10') }}</span>
      </div>
      <ul class="flx-bs links">
        <li v-for="(item,index) in links" :key="index">
          <a target="_blank" :href="item.url">
            <span class="logo"><img :src="item.logo"/></span>
            <p class="name">{{item.name}}</p>
          </a>
        </li>
      </ul>
    </div>
    <div class="flx-bs container">
      <div class="left">
        <div class="part">
          <div class="head flx-bc">
            <span class="title"><i class="icon icon-tb"></i>{{output.label}}</span>
            <a :href="output.url" target="_blank" class="link">{{ $C('china','goLabel','Go') }}</a>
          </div>
          <div class="box">
            <h3 class="title">{{output.title}}</h3>
            <div class="outputBox" id="output"></div>
          </div>
        </div>
        <div class="part">
          <div class="head flx-bc">
            <span class="title"><i class="icon icon-tb"></i>{{outputArea.label}}</span>
            <a :href="outputArea.url" target="_blank" class="link">{{ $C('china','goLabel','Go') }}</a>
          </div>
          <div class="box">
            <h3 class="title">{{outputArea.title}}</h3>
            <div class="outputAreaBox" id="outputArea"></div>
          </div>
        </div>
      </div>
      <div class="middle">
        <div class="map" id="map"></div>
      </div>
      <div class="right">
        <div class="part">
          <div class="head flx-bc">
            <span class="title"><i class="icon icon-milk"></i>{{drink.label}}</span>
            <a :href="drink.url" target="_blank" class="link">{{ $C('china','goLabel','Go') }}</a>
          </div>
          <div class="box">
            <h3 class="title">{{drink.title}}</h3>
            <div class="drinkBox" id="drink"></div>
          </div>
        </div>
        <div class="part">
          <div class="head"><span class="title"><i class="icon icon-news"></i>{{ $C('china','headNews','最新动态') }}</span></div>
          <ul class="nlist">
            <li v-for="(item,index) in news" :key="index" @click="newsShow=true;newsUrl=item.url">
              <h3><a>{{item.title}}</a></h3>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <News v-if="newsShow" :visible.sync="newsShow" :title="$C('china','headNews','最新动态')" :url="newsUrl"></News>
    <Brands v-if="brandShow" :visible.sync="brandShow" :title="$C('china','linkBrand','中国市场乳制品品牌 TOP 30')" :data="brandData"></Brands>
    <Process v-if="processShow" :visible.sync="processShow" :title="$C('china','linkChain','中国乳制品产业链')" :data="processData"></Process>
    <Teas v-if="teaShow" :visible.sync="teaShow" :title="$C('china','linkTea','中国市场茶饮品牌 TOP 10')" :data="teaData"></Teas>
  </div>
</template>

<script>
import axios from "axios"
import echarts from 'echarts'
import 'echarts/map/js/china'
import News from '../common/newsDig.vue'
import Brands from './brand.vue'
import Process from './process.vue'
import Teas from './tea.vue'
import { mediaUrl } from '@/cms/config'
export default {
  name: '',
  components: { News,Brands,Process,Teas},
  data() {
    return {
      output: {},
      outputArea: {},
      drink: {},
      news: [],
      links: [],
      mapData: [],
      newsShow: false,
      newsUrl: {},
      brandShow: false,
      brandData: {},
      processShow: false,
      processData: [],
      teaShow: false,
      teaData: {}
    };
  },
  mounted() {
  },
  computed: {
    rootVars() {
      const bg = this.$C('china', 'pageBg', '')
      return bg ? {
        backgroundImage: `url("${mediaUrl(bg)}")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      } : {}
    },
  },
  watch: {
    '$route.path':{
      handler(path){
        if(path==='/china'){
          // this.fetchData('/assets/china.json')
          this.getData('china')
        }
      },
      immediate: true
    }
  },
  methods: {
    getData(name){
      let params = {fileName: name}
      axios.post(this.$baseUrl+'/api/web/file/data/query',params).then(res => {
        if(res.data.code === 200){
          const jsonData = res.data.data
          this.output = jsonData.output
          this.outputArea = jsonData.outputArea
          this.drink = jsonData.drink
          this.news = jsonData.news
          this.links = jsonData.links
          this.mapData = jsonData.mapData
          this.brandData = jsonData.brandData
          this.processData = jsonData.process
          this.teaData = jsonData.teaData
          this.$nextTick(() => {
            this.outputEchart()
            this.outputAreaEchart()
            this.drinkEchart()
            this.echartsMap()
          })
        }
      })
    },
    fetchData(path) {
      axios.get(path+'?t=' + Date.now()).then(res => {
        const jsonData = res.data
        this.output = jsonData.output
        this.outputArea = jsonData.outputArea
        this.drink = jsonData.drink
        this.news = jsonData.news
        this.links = jsonData.links
        this.mapData = jsonData.mapData
        this.brandData = jsonData.brandData
        this.processData = jsonData.process
        this.teaData = jsonData.teaData
        this.$nextTick(() => {
          this.outputEchart()
          this.outputAreaEchart()
          this.drinkEchart()
          this.echartsMap()
        })
      })
    },
    outputEchart(){
      var chart = echarts.init(document.getElementById('output'));
      let dataX = this.output.data.map(it => {
        return it.time
      })
      let dataY = this.output.data.map(it => {
        return it.value
      })
      // 清空图表
      chart.clear();
      var option = {
        grid: {
          left: 0,   // 左侧距离
          right: 121,  // 右侧距离
          top: 84,   // 可选：顶部距离
          bottom: 0, // 可选：底部距离
          containLabel: true // 确保标签不被裁剪
        },
        tooltip: {
          trigger: 'axis',
          textStyle: {
            color: '#fff', 
            fontSize: 36,
          },
          formatter: '{b}：{c}万吨'
        },
        xAxis: {
          type: 'category',
          data: dataX,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#2A54A2', // 设置 x 轴线的颜色
              width: 3,
            }
          },
          boundaryGap: false,
          axisLabel: {
            color: '#fff', // 文字颜色
            fontSize: 28,   // 字体大小
            margin: 24
          }
        },
        yAxis: {
          type: 'value',
          axisLine: { 
            lineStyle: {
              color: '#2A54A2',
              width: 3,
            }
          },
          splitLine: { 
            lineStyle: {
              color: '#2A54A2',
              type: 'dashed',
              width: 2,
            }
          },
          axisTick: { show: false },
          axisLabel: {
            color: '#fff', // 文字颜色
            fontSize: 30,   // 字体大小
            margin: 42,
            formatter: '{value}万吨'
          },
        },
        series: [
          {
            data: dataY,
            type: 'line',
            areaStyle: {
              color: '#2A54A2'
            },
            lineStyle: {
              color: '#0CFBFF',
              width: 3
            }
          }
        ]
      };
      chart.setOption(option)
    },
    outputAreaEchart(){
      var chart = echarts.init(document.getElementById('outputArea'));
      let dataX = this.outputArea.data.map(it => {
        return it.time
      })
      let dataY = this.outputArea.data.map(it => {
        return it.value
      })
      let source = []
      this.outputArea.data.forEach(it => {
        source.push([it.value,it.name])
      })
      source.unshift(['amount', 'area'])
      // 清空图表
      chart.clear();
      var option = {
        dataset: {
          source: source
        },
        grid: { 
          left: 0,   // 左侧距离
          right: 121,  // 右侧距离
          top: 51,   // 可选：顶部距离
          bottom: 0, // 可选：底部距离
          containLabel: true // 确保标签不被裁剪
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          textStyle: {
            color: '#fff', 
            fontSize: 36,
          }
        },
        xAxis: { 
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#2A54A2', // 设置 x 轴线的颜色
              width: 3,
            }
          },
          splitLine: {
            show: false
          },
          boundaryGap: false,
          axisLabel: {
            color: '#fff', // 文字颜色
            fontSize: 28,   // 字体大小
            margin: 24,
            rotate: 45
          }
        },
        yAxis: { 
          name: 'amount',
          axisLine: { 
            lineStyle: {
              color: '#2A54A2',
              width: 3,
            }
          },
          splitLine: { 
            lineStyle: {
              color: '#2A54A2',
              type: 'dashed',
              width: 2,
            }
          },
          axisTick: { show: false },
          axisLabel: {
            color: '#fff', // 文字颜色
            fontSize: 30,   // 字体大小
            margin: 42,
          },
        },
        visualMap: {
          type: 'piecewise', //分段性
          orient: 'horizontal',
          left: 'center',
          min: 0,
          max: 1000,
          pieces: [           // 可自定义分段
              { min: 601, 
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                  {offset: 0, color: '#00AB6E'},
                  {offset: 1, color: '#008C5A'}
                ])
              },
              { min: 301, max: 600, 
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                  {offset: 0, color: '#0081C4'},
                  {offset: 1, color: '#0444A8'}
                ])
              },
              { max: 300, 
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                  {offset: 0, color: '#DA6300'},
                  {offset: 1, color: '#9A4A01'}
                ])
              }
          ],
          dimension: 0,
          show: false
        },
        series: [
          {
            type: 'bar',
            barWidth: 30,
            encode: {
              x: 'area',
              y: 'amount'
            }
          }
        ]
      }
      chart.setOption(option)
    },
    drinkEchart(){
      var chart = echarts.init(document.getElementById('drink'));
      let series = [] 
      let names = []
      let dataX = []
      this.drink.data.forEach(it => {
        series.push({
          type: 'line',
          symbol: 'none',
          lineStyle: {width:3},
          name: it.name,
          data: it.data.map(item => item.value)
        })
        names.push(it.name)
      })
      dataX = this.drink.data[0].data.map(item => item.time)
      // 清空图表
      chart.clear();
      var option = {
        grid: {
          left: 0,   // 左侧距离
          right: 121,  // 右侧距离
          top: 150,   // 可选：顶部距离
          bottom: 0, // 可选：底部距离
          containLabel: true // 确保标签不被裁剪
        },
        tooltip: {
          trigger: 'axis',
          textStyle: {
            color: '#fff', 
            fontSize: 36,
          },
        },
        legend: {
          data: names,
          right: 121,
          top: 50,
          textStyle: {
            fontSize: 36,
            color: '#fff',
            padding:[0,10]
          },
          icon: 'rect', 
          itemWidth: 68,
          itemHeight: 3,
          itemGap: 65
        },
        color: ['#FFBE0C','#A20CFF','#1CFF0C','#AECDFF','#FF510C','#0C85FF'],
        xAxis: {
          type: 'category',
          data: dataX,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#2A54A2', // 设置 x 轴线的颜色
              width: 3,
            }
          },
          boundaryGap: false,
          axisLabel: {
            color: '#fff', // 文字颜色
            fontSize: 28,   // 字体大小
            margin: 24
          }
        },
        yAxis: {
          type: 'value',
          name: '单位:kg', // 直接显示单位
          nameLocation: 'end', // 单位位置：'start'、'middle'、'end'
          nameGap: 50, // 单位与轴线的距离
          nameTextStyle: {
              color: 'rgba(255,255,255,0.5)',
              fontSize: 36
          },
          axisLine: { 
            lineStyle: {
              color: '#2A54A2',
              width: 3,
            }
          },
          splitLine: { 
            lineStyle: {
              color: '#2A54A2',
              type: 'dashed',
              width: 2,
            }
          },
          axisTick: { show: false },
          axisLabel: {
            color: '#fff', // 文字颜色
            fontSize: 30,   // 字体大小
            margin: 32,
          },
        },
        series: series
      };
      chart.setOption(option)
    },
    echartsMap(){
      var that = this
      var map = echarts.init(document.getElementById('map'));
      // 设置地图配置
      var option = {
        title: {
          text: '中国乳业品牌分布图',
          left: 'center',
          top: 90,
          textStyle: {
            color: '#ffffff',
            fontSize: 60,
            fontWeight: 'bold'
          },
        },
        grid: {
          left: 0,   // 左侧距离
          right: 0,  // 右侧距离
          top: 0,   // 可选：顶部距离
          bottom: 0, // 可选：底部距离
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0,0,0,0.6)',
          borderRadius: 15,
          textStyle: {
            color: '#ffffff',
            fontSize: 36
          },
          formatter(params) {
            const data = params.data;
            if (!data) {
                return ``
            }
            return  `
            <div style='padding: 40px;font-size:36px;line-height:50px;position:relative'>
              <h3 style='font-size:42px;font-weight:600;margin-bottom:10px;line-height:60px'>${data.name}</h3>
              <p style="white-space:wrap;">${data.value}</p>
            </div>`
          },
        },
         geo: [
            //第一层投影
            {
                left: 15,
                top: 15,
                width: '100%',
                height: '100%',
                map: 'china',
                zlevel: -1,
                roam: false, // 鼠标缩放+平移
                show: true,
                selectedMode: false,
                silent: true, // 禁用鼠标交互
                label: {
                    normal: {
                        show: false
                    },
                    emphasis: {
                        show: false
                    }
                },
                itemStyle: {
                    normal: {
                        areaColor: "#0345A1",
                        shadowOffsetX: 0,
                        shadowOffsetY: 0,
                        // shadowBlur: 10
                    },
                    emphasis: {
                        show: false
                    }
                },
                emphasis:{
                    show:false
                },
                tooltip:{
                    show:false
                }
            }
        ],
        series: [
          {
            // 上层地图
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            name: '中国地图',
            type: 'map',
            mapType: 'china',
            roam: true,
            itemStyle: {
              // areaColor: '#387FE9',
              areaColor: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                {offset: 0, color: '#387FE9'},
                {offset: 1, color: '#225FBA'}
              ]),
              borderWidth: 3,
              borderColor: '#42AAFF',
            },
            emphasis: {
              itemStyle: {
                  areaColor: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                    {offset: 0, color: '#F9B841'},
                    {offset: 1, color: '#FF6524'}
                  ]),
                  borderWidth: 3,
                  borderColor: '#FFD942',
              }
            },
            label: {
              normal: {
                show: true,
                color: '#ffffff',
                fontSize: 36
              },
              emphasis: {
                color: '#ffffff',
                fontSize: 36
              },
            },
            data: that.mapData,
          }
        ],
      }
      // 设置配置项
      map.setOption(option);
    },
  },
};
</script>
<style lang="less" scoped>
@import '@/styles/china';
</style>